import { Route, Routes } from "react-router-dom";
import { OnboardingStepper } from "./stepper";
import { CurrentStep } from "./stepper/CurrentStep";
import { RoutesWithEmail } from "@api/RoutesWithEmail";
import { UserActivation } from "src/routes/activate";
import { ThankyouPage } from "src/routes/thankyoupage";
import { LoadingSlider } from "./stepper/questions/loadingSlider";

export const Walky = () => {
  return (
    <Routes>
      <Route element={<OnboardingStepper />} path="/onboarding">
        <Route element={<CurrentStep />} path="/onboarding/:stepIndex" />
      </Route>
      <Route element={<RoutesWithEmail />}>
        <Route element={<UserActivation variant='walky'/>} path="/activate" />
        <Route element={<ThankyouPage />} path="/thankyou" />
      </Route>
      <Route path="/loading-slider" element={<LoadingSlider />} />
    </Routes>
  );
};
